import { getApp } from '../../main.js';
import axios from 'axios';
import store from './store';
import Swal from 'sweetalert2';
import { EventBus } from './eventBus';  // EventBus를 임포트

//export const API_URL = app.config.globalProperties.$VUE_APP_API_URL;
//export const SOCKET_URL = app.config.globalProperties.$VUE_APP_SOCKET_URL;
//export const DOMAIN = app.config.globalProperties.$VUE_APP_DOMAIN;
export function API_URL() {
    return getApp().config.globalProperties['$VUE_APP_API_URL'];
}
export function SOCKET_URL() {
    return getApp().config.globalProperties['$VUE_APP_SOCKET_URL'];
}
export function DOMAIN() {
    return getApp().config.globalProperties['$VUE_APP_DOMAIN'];
}

export function MEMBER_API_URL() {
    return getApp().config.globalProperties['$VUE_APP_MEMBER_API_URL'];
}

const AxiosPost = async (url, data, checkToken, onSuccess, onFailure) => {
    try {
        var add_url = (url.includes('api/member') ? MEMBER_API_URL() : API_URL()) + url;

        if (store.state.user.id != null) {
            if (!('user_id' in data))
                data.user_id = store.state.user.id;
        }
        if (store.state.user.token != null) {
            if (!('token' in data))
                data.token = store.state.user.token;
        }
        if (store.state.secret != null) {
            if (!('secret' in data))
                data.secret = store.state.secret;
        }
        data.os = store.os;

        const response = await axios.post(add_url, data);


        // 여기서 응답값을 확인하여 특정 행동 수행
        if (response.status == 200) {
            // 응답이 성공일 때 특정 작업 수행
            
            if (checkToken)
            {
                switch (response.data.code) {
                    case '502':           // EXPIRED_TOKEN
                        Swal.fire({
                            icon: 'error',
                            html: '장시간 입력이 없어 로그아웃 처리되었습니다.<br>재로그인 바랍니다.',
                        }).then(() => {
                            EventBus.emit('logOut');
                        });
                        break;
                    case '501':           // INVALLID_TOKEN
                    case '503':           // NOT_FOUND_TOKEN
                        Swal.fire({
                            icon: 'error',
                            html: '본인 확인이 필요합니다.<br>재로그인 바랍니다.',
                        }).then(() => {
                            EventBus.emit('logOut');
                        });
                        break;
                    default:
                        //console.log('Response was successful:', response);
                        if (onSuccess) {
                            onSuccess(response);
                        }
                        if (response.data.refreshToken != null) {
                            store.state.user.token = response.data.refreshToken;
                            //console.log(">> Token Refresh! : " + store.state.user.token);
                        }
                        break;
                }
            }
            else
            {
                //console.log('Response was successful:', response);
                if (onSuccess) {
                    onSuccess(response);
                }
                if (response.data.refreshToken != null) {
                    store.state.user.token = response.data.refreshToken;
                    //console.log(">> Token Refresh! : " + store.state.user.token);
                }
            }
            
        }
        else {
            // 응답이 실패일 때 특정 작업 수행
            console.error('Response was not successful:', response);
            if (onFailure) {
                onFailure(response);
            }
        }
    } catch (error) {
        console.error('Error sending data:', error);
    }
};

export function openPopup(url, name, specs) {
    const popup = window.open(url, name, specs);

    if (popup) {
        store.commit('addPopup', { url, name, specs });

        // 팝업이 닫힐 때의 이벤트 리스너 등록
        const interval = setInterval(() => {
            if (popup.closed) {
                clearInterval(interval);
                store.commit('removePopup', url);
            }
        }, 1000);
    }

    return popup;
}

export function showToast(_icon, _content, position = 'top') {
    Swal.fire({
        //icon: _icon,
        text: _content,
        position: position,
        showConfirmButton: false,
        timer: 1500,
        customClass: {
            popup: 'custom-toast' // 사용자 정의 CSS 클래스를 팝업에 적용합니다.
        },
        backdrop: false,  // backdrop 제거 
        heightAuto: false  // 자동 높이 조정 비활성화
    });
}

export function checkToken(onSuccess)
{
    var form = {};
    if (store.state.user.token != null)
    {
        AxiosPost('users/checkToken', form, false, response => {
            switch (response.data.code) {
                case '200':
                    if (onSuccess != null)
                        onSuccess();
                    break;
                case '502':           // EXPIRED_TOKEN
                    Swal.fire({
                        icon: 'error',
                        html: '장시간 입력이 없어 로그아웃 처리되었습니다.<br>재로그인 바랍니다.',
                    }).then(() => {
                        EventBus.emit('logOut');
                    });
                    break;
                case '501':           // INVALLID_TOKEN
                case '503':           // NOT_FOUND_TOKEN
                    Swal.fire({
                        icon: 'error',
                        html: '본인 확인이 필요합니다.<br>재로그인 바랍니다.',
                    }).then(() => {
                        EventBus.emit('logOut');
                    });
                    break;
            }
        });
    }
    else
    {
        onSuccess();
    }
}

export default {
    AxiosPost,
    showToast,
    checkToken,
    openPopup,
    SOCKET_URL,
    DOMAIN
};